import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useDebounce } from '../../Hooks/useDebounce';
import { useLocation } from 'react-router-dom';

const SearchBox = function SearchBox({
  setSearchValues,
  searchValues,
  width = 'unset',
}) {
  const [inputValue, setInputValue] = useState(searchValues?.searchBox || '');
  const [debouncedValue] = useDebounce(inputValue, 600); //wait after finish typing

  const location = useLocation();
  useEffect(() => {
    setSearchValues({
      ...searchValues,
      ...{ searchBox: debouncedValue },
    });
  }, [debouncedValue]);

  useEffect(() => {
    setInputValue(searchValues?.searchBox || '');
  }, [searchValues?.searchBox]);

  useEffect(() => {
    setInputValue('');
  }, [location?.pathname]);

  const intl = useIntl();
  return (
    <TextField
      id="searchbox"
      placeholder={intl.messages.SEARCH}
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      sx={{ width }}
      slotProps={{
        input: {
          style: {
            borderRadius: '50px',
          },
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        },
      }}
      variant="outlined"
      size="small"
    />
  );
};

export default SearchBox;
